"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitOnChainFuelAttestationBodyChainNameEnum = exports.SubmitOnChainFuelAttestationBodyToJSON = exports.SubmitOnChainFuelAttestationBodyFromJSONTyped = exports.SubmitOnChainFuelAttestationBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
function SubmitOnChainFuelAttestationBodyFromJSON(json) {
    return SubmitOnChainFuelAttestationBodyFromJSONTyped(json, false);
}
exports.SubmitOnChainFuelAttestationBodyFromJSON = SubmitOnChainFuelAttestationBodyFromJSON;
function SubmitOnChainFuelAttestationBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fuelAmount': json['fuelAmount'],
        'walletAddress': json['walletAddress'],
        'chainName': json['chainName'],
        'notes': !(0, runtime_1.exists)(json, 'notes') ? undefined : json['notes'],
    };
}
exports.SubmitOnChainFuelAttestationBodyFromJSONTyped = SubmitOnChainFuelAttestationBodyFromJSONTyped;
function SubmitOnChainFuelAttestationBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fuelAmount': value.fuelAmount,
        'walletAddress': value.walletAddress,
        'chainName': value.chainName,
        'notes': value.notes,
    };
}
exports.SubmitOnChainFuelAttestationBodyToJSON = SubmitOnChainFuelAttestationBodyToJSON;
/**
* @export
* @enum {string}
*/
var SubmitOnChainFuelAttestationBodyChainNameEnum;
(function (SubmitOnChainFuelAttestationBodyChainNameEnum) {
    SubmitOnChainFuelAttestationBodyChainNameEnum["Ethereum"] = "ethereum";
    SubmitOnChainFuelAttestationBodyChainNameEnum["Base"] = "base";
    SubmitOnChainFuelAttestationBodyChainNameEnum["Solana"] = "solana";
})(SubmitOnChainFuelAttestationBodyChainNameEnum = exports.SubmitOnChainFuelAttestationBodyChainNameEnum || (exports.SubmitOnChainFuelAttestationBodyChainNameEnum = {}));
